// extracted by mini-css-extract-plugin
export default {"bubble":"Bubblewrap_bubble__6mrUK","bubble_popped":"Bubblewrap_bubble_popped__M7M++"};